import { Link } from 'react-router-dom';
import { KeyIcon, ArrowTopRightOnSquareIcon } from '@heroicons/react/24/outline';
import { ROUTES } from '@/utils/constants';

export default function AccessCodesPanel() {
  return (
    <div className="p-4 flex flex-col gap-4">
      <div className="flex items-start gap-3">
        <div className="w-10 h-10 rounded-lg bg-primary/10 text-primary flex items-center justify-center shrink-0">
          <KeyIcon className="w-5 h-5" />
        </div>
        <div className="text-sm text-base-content/80 leading-relaxed">
          Issue, print and track the codes parents use to link themselves to their children.
        </div>
      </div>

      <Link to={ROUTES.ACCESS_CODES} className="btn btn-primary btn-sm gap-2 self-start">
        <ArrowTopRightOnSquareIcon className="w-4 h-4" />
        Open Access codes
      </Link>
    </div>
  );
}
